/*
 *
 * Product Reviews IO
 * Only available on Spain 🇪🇸
 *
 */

export default class ProductReviewsIO extends HTMLElement {
	constructor() {
		super();
		this.review = {};
		this.sku = this.dataset.sku;
		this.store = 'mustelaes-prod.myshopify.com';
	}

	async connectedCallback() {
		await this.fetchReviews().then((data) => this.updateStructuredData(data));
	}

	async fetchReviews() {
		try {
			const url = `https://api.reviews.io/product/rating-batch?store=${this.store}&sku=${this.sku}`;
			const options = {method: 'GET', headers: {accept: 'application/json'}};
			const response = await fetch(url, options);
			const data = await response.json();
			return data;
		} catch (error) {
			console.error(error);
		}
	}

	/*
	 *
	 * updateStructuredData
	 * update Structured Data after page load
	 *
	 */
	updateStructuredData(review) {
		if (!review.length) return;
		const {average_rating, num_ratings} = review[0];

		let productSchema = document.querySelector('#product-structured-data');

		if (productSchema?.firstChild) {
			const jsonProdSchem = JSON.parse(productSchema.firstChild.nodeValue);

			if (average_rating && num_ratings) {
				const round_decimal = (num) => Math.round(num * 100) / 100;

				jsonProdSchem.aggregateRating = {
					'@type': 'AggregateRating',
					ratingValue: round_decimal(average_rating),
					reviewCount: num_ratings,
				};
			}

			productSchema.firstChild.nodeValue = JSON.stringify(jsonProdSchem);
		}
	}

	disconnectedCallback() {}
}
